import * as angular from 'angular';

export const SearchFieldComponent: angular.IComponentOptions = {
  controller: class {
    query = '';
    placeholder = 'Search...';

    onUpdate: (args: { $query: string }) => void;
    handleChange() {
      this.onUpdate({
        $query: this.query,
      });
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    onUpdate: '&',
  },
  template: `
    <div>
      <input
        class="form-control form-control-sm icon-search-spyglass"
        ng-model="ctrl.query"
        ng-change='ctrl.handleChange()'
        type="text"
        placeholder="{{ctrl.placeholder}}"
      />
    </div>
  `,
};
